import { mediaType } from '@components/libs/typeInterface';
import React from 'react';
import Slider from 'react-slick';
interface IThumbSlider {
  settingsThumbs: {};
  // tslint:disable-next-line: no-any
  setSlider2: (x: any) => void;
  // tslint:disable-next-line: no-any
  nav1: any;
  media: mediaType[];
}

const ThumbSlider = (props: IThumbSlider) => {
  const { settingsThumbs, setSlider2, nav1, media } = props;
  return (
    <>
      <Slider
        className="w-full h-full slider-nav lg:py-7"
        {...settingsThumbs}
        // @ts-ignore
        asNavFor={nav1}
        ref={(slider) => setSlider2(slider)}
      >
        {media.map((item, index) => (
          <div key={index}>
            <div className="w-16 h-16 flex items-center justify-center border-2 cursor-pointer border-transparent xs:mx-2.5 lg:mx-0 lg:mb-3">
              <img className="w-11/12 h-11/12 object-contain" src={item.value} />
            </div>
          </div>
        ))}
      </Slider>
    </>
  );
};

export default ThumbSlider;
